import type { ElementType } from "react";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AltRouteOutlinedIcon from "@mui/icons-material/AltRouteOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import BrandingWatermarkOutlinedIcon from "@mui/icons-material/BrandingWatermarkOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import LocalTaxiOutlinedIcon from "@mui/icons-material/LocalTaxiOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import TravelExploreOutlinedIcon from "@mui/icons-material/TravelExploreOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";

export const iconForMenu = (
  name: string,
  fallback?: ElementType
): ElementType | undefined => {
  const label = name.toLowerCase();

  if (label.includes("live") && label.includes("dashboard")) {
    return QueryStatsOutlinedIcon;
  }
  if (label.includes("scheduler") || label.includes("shift")) {
    return CalendarMonthOutlinedIcon;
  }
  if (label.includes("dashboard")) return DashboardOutlinedIcon;
  if (label.includes("billing")) return fallback ?? ReceiptLongOutlinedIcon;
  if (label.includes("report")) return fallback ?? AssessmentOutlinedIcon;
  if (label.includes("upload")) return UploadFileOutlinedIcon;
  if (label.includes("search")) return TravelExploreOutlinedIcon;
  if (label.includes("approval")) return TaskAltOutlinedIcon;
  if (label.includes("request")) {
    return AssignmentTurnedInOutlinedIcon;
  }
  if (label.includes("grievance")) return SupportAgentOutlinedIcon;
  if (label.includes("security") || label.includes("access")) {
    return SecurityOutlinedIcon;
  }
  if (label.includes("announcement")) return CampaignOutlinedIcon;
  if (label.includes("event") || label.includes("log")) {
    return EventNoteOutlinedIcon;
  }
  if (label.includes("brand")) return BrandingWatermarkOutlinedIcon;
  if (label.includes("category")) return CategoryOutlinedIcon;
  if (label.includes("common point")) return PlaceOutlinedIcon;
  if (label.includes("sequenc")) return FormatListNumberedOutlinedIcon;
  if (
    label.includes("location") ||
    label.includes("zone") ||
    label.includes("city")
  ) {
    return LocationOnOutlinedIcon;
  }
  if (label.includes("map")) return MapOutlinedIcon;
  if (label.includes("route")) return AltRouteOutlinedIcon;
  if (label.includes("vendor")) return LocalShippingOutlinedIcon;
  if (label.includes("cab")) return LocalTaxiOutlinedIcon;
  if (label.includes("driver")) return PersonOutlineOutlinedIcon;
  if (label.includes("employee")) return BadgeOutlinedIcon;
  if (label.includes("organization") || label.includes("organisation")) {
    return ApartmentOutlinedIcon;
  }
  if (label.includes("team")) return GroupsOutlinedIcon;
  if (label.includes("trip")) return DirectionsCarOutlinedIcon;
  if (label.includes("profile")) return AccountCircleOutlinedIcon;
  if (label.includes("user") || label.includes("admin")) {
    return ManageAccountsOutlinedIcon;
  }
  if (label.includes("role") || label.includes("config")) {
    return SettingsOutlinedIcon;
  }
  if (label.includes("setting")) return SettingsOutlinedIcon;
  if (label.includes("transport")) return LocalShippingOutlinedIcon;

  return fallback;
};
